/**
 * @generated SignedSource<<9f3e00c368c441379896327acd6e6ec7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CitizensOrder = "mostVotingPower" | "shuffle" | "%future added value";
export type DelegatesOrder = "mostDelegates" | "mostVotingPower" | "weightedRandom" | "%future added value";
export type HomePageRouteQuery$variables = {
  citizensOrderBy: CitizensOrder;
  orderBy: DelegatesOrder;
  seed?: string | null;
};
export type HomePageRouteQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CitizensContainerFragment" | "DelegatesContainerFragment" | "OverviewMetricsContainerFragment">;
};
export type HomePageRouteQuery = {
  response: HomePageRouteQuery$data;
  variables: HomePageRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "citizensOrderBy"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "seed"
},
v3 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v4 = {
  "kind": "Variable",
  "name": "seed",
  "variableName": "seed"
},
v5 = [
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "citizensOrderBy"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v3/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ResolvedName",
      "kind": "LinkedField",
      "name": "resolvedName",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "DelegateStatement",
  "kind": "LinkedField",
  "name": "statement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "twitter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discord",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "decimals",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TokenAmount",
    "kind": "LinkedField",
    "name": "amount",
    "plural": false,
    "selections": (v10/*: any*/),
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "VotingPower",
  "kind": "LinkedField",
  "name": "tokensRepresented",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCitizen",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageRouteQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DelegatesContainerFragment"
      },
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "CitizensContainerFragment"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OverviewMetricsContainerFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomePageRouteQuery",
    "selections": [
      {
        "alias": "voters",
        "args": (v6/*: any*/),
        "concreteType": "DelegatesConnection",
        "kind": "LinkedField",
        "name": "delegates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegatesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Delegate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "voters",
        "args": (v6/*: any*/),
        "filters": [
          "orderBy",
          "seed"
        ],
        "handle": "connection",
        "key": "DelegatesContainerFragment_voters",
        "kind": "LinkedHandle",
        "name": "delegates"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RetroPGF",
        "kind": "LinkedField",
        "name": "retroPGF",
        "plural": false,
        "selections": [
          {
            "alias": "voters",
            "args": (v5/*: any*/),
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "badgeholders",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Metrics",
        "kind": "LinkedField",
        "name": "metrics",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "delegatedSupply",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TokenAmount",
            "kind": "LinkedField",
            "name": "totalSupply",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "quorum",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90da73125af3e9857621b76313f44af9",
    "id": null,
    "metadata": {},
    "name": "HomePageRouteQuery",
    "operationKind": "query",
    "text": "query HomePageRouteQuery(\n  $orderBy: DelegatesOrder!\n  $seed: String\n  $citizensOrderBy: CitizensOrder!\n) {\n  ...DelegatesContainerFragment_1cZi0K\n  ...CitizensContainerFragment_1irrRw\n  ...OverviewMetricsContainerFragment\n}\n\nfragment CitizensContainerFragment_1irrRw on Query {\n  retroPGF {\n    voters: badgeholders(orderBy: $citizensOrderBy) {\n      id\n      ...VoterCardFragment\n    }\n  }\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n      ...ENSAvatarFragment\n    }\n  }\n  tokensRepresented {\n    amount {\n      ...TokenAmountDisplayFragment\n    }\n  }\n  isCitizen\n}\n\nfragment DelegatesContainerFragment_1cZi0K on Query {\n  voters: delegates(first: 30, orderBy: $orderBy, seed: $seed) {\n    edges {\n      node {\n        id\n        ...VoterCardFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ENSAvatarFragment on ResolvedName {\n  name\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment OverviewMetricsContainerFragment on Query {\n  metrics {\n    delegatedSupply {\n      amount\n      ...TokenAmountDisplayFragment\n    }\n    totalSupply {\n      amount\n      ...TokenAmountDisplayFragment\n    }\n    quorum {\n      amount {\n        ...TokenAmountDisplayFragment\n      }\n    }\n  }\n}\n\nfragment TokenAmountDisplayFragment on TokenAmount {\n  amount\n  decimals\n  currency\n}\n\nfragment VoterCardFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      name\n    }\n  }\n  statement {\n    summary\n  }\n  ...VoterPanelActionsFragment\n  ...DelegateProfileImageFragment\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n"
  }
};
})();

(node as any).hash = "c38a95462e37daf95c6a572617503247";

export default node;
